import React, { useContext, useEffect } from 'react'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { graphql } from 'gatsby'
import { Layout } from '../components/layout'
import RichText from '../components/rich-text'
import { Seo } from '../components/seo'
import { CustomLink } from '../utils/custom-link'
import ContactPage from '../types/pages/contact'
import { TextColourContext } from '../context/text-colour-context-provider'

export const query = graphql`
  query ContactQuery {
    prismicContact {
      ...ContactPage
    }
  }
`

const Contact = ({ data }) => {
  const { setTextColour } = useContext(TextColourContext)
  useEffect(() => {
    setTextColour('light')
  }, [setTextColour])

  if (!data) return null

  const pageData = data.prismicContact.data

  return (
    <>
      <Seo data={pageData} />
      <div className="contact__content">
        {pageData.page_title && <h1>{pageData.page_title}</h1>}
        <div className="contact__message">
          {pageData.page_text.richText && (
            <RichText field={pageData.page_text.richText} />
          )}
        </div>
      </div>
    </>
  )
}
export default withPrismicPreview(Contact)
